import React from "react";
import { Container } from "@mui/material";
import { Page } from "~/layout";
import { UserDetails } from "./user-details";

export function UserDetailsPage({
  navigation,
  breadcrumbs,
}: {
  navigation: React.ReactNode;
  breadcrumbs?: React.ReactNode;
}) {
  return (
    <Page title="User Details" navigation={navigation}>
      <Container fixed>
        {breadcrumbs}
        <UserDetails />
      </Container>
    </Page>
  );
}
